<template>
<div class="chapter">
<div class="inner_page">
<h1>Kirby’s Last Circus</h1>
<h3 class="sigil_not_in_toc">Ross H. Spencer</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_title.vue?6fa58cc6